import { render, staticRenderFns } from "./basket-form-delivery-types.vue?vue&type=template&id=efc01546"
import script from "./basket-form-delivery-types.vue?vue&type=script&lang=js"
export * from "./basket-form-delivery-types.vue?vue&type=script&lang=js"
import style0 from "./basket-form-delivery-types.vue?vue&type=style&index=0&id=efc01546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
